import { render, staticRenderFns } from "./OrganizationSelector.vue?vue&type=template&id=7656b780"
import script from "./OrganizationSelector.vue?vue&type=script&lang=js"
export * from "./OrganizationSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports